<template>
  <div v-if="fragments.length > 0">
    <template v-for="(fragment, index) in fragments">
      <span v-html="fragment.content" :key="index" v-if="!fragment.type"></span>
      <CmsSmartCallout
        :key="index"
        v-if="fragment.type === 'CmsSmartCallout'"
        :uid="fragment.content"
      ></CmsSmartCallout>
      <CmsSmartTextBox
        :key="index"
        v-if="fragment.type === 'CmsSmartTextBox'"
        :uid="fragment.content"
      ></CmsSmartTextBox>
    </template>
  </div>
  <div v-else v-html="html"></div>
</template>

<script setup lang="ts">
/* eslint-disable */
import { computed } from "vue";
import CmsSmartCallout from "./cms-smart-callout.vue";
import CmsSmartTextBox from "./cms-smart-text-box.vue";

const props = defineProps<{ html: string }>();

// break down html
let regex = /(<\/?CmsSmartCallout>|<\/?CmsSmartTextBox>)/g;
const fragments = computed(() => {
  let parts = props.html.split(regex);
  let type = "";
  let fragmentArray = [] as { type: string; content: string }[];
  for (let i = 0; i < parts.length; i++) {
    if (regex.test(parts[i])) {
      if (parts[i].startsWith("</")) {
        type = "";
      } else {
        type = parts[i].replace("<", "").replace(">", "");
      }
    } else {
      fragmentArray.push({ type, content: parts[i] });
    }
  }

  return fragmentArray;
});
</script>

<style lang="less"></style>
